interface ICheckSlideInsideContainerParams {
  containerNode: HTMLElement;
  slideNode: HTMLElement;
}

export function checkSlideInsideContainer(params: ICheckSlideInsideContainerParams): boolean {
  const { containerNode, slideNode } = params;

  const containerRect = containerNode.getBoundingClientRect();
  const slideRect = slideNode.getBoundingClientRect();

  return slideRect.left >= containerRect.left && slideRect.right <= containerRect.right;
}
